import { ActionClass } from '@platform-frontend/util';

export interface ActionFilter {
  matchesAny(actions: ActionClass[]): boolean;
}
